<template>
    <div class="countDownBox">
        <div class="bgBox">
            <img :src="banner_img" />

            <div class="endCountDown">
                <countDown ref="countDown" :timestamp="remainTime" @callBack="onCountDownCallBack" :hasDay="true">
                    <p class="p1">距离活动结束还剩</p>
                    <div class="pBox">
                        <p><span>{{ timeInfo.d }}</span>天<span>{{ timeInfo.h }}</span>:<span>{{ timeInfo.m }}</span>:<span>{{ timeInfo.s }}</span></p>
                    </div>
                </countDown>
            </div>
        </div>
    </div>
</template>

<script>
import countDown from '@/components/countDown/countDown.vue'

export default {
    name: 'countDownBox',
    props: {
        remainTime: {
            type: Number,
            default: 0
        },
        banner_img: {
            type: String,
        }
    },
    components: {
        countDown
    },
    data () {
        return {
            state: 0, // 0 未开始 1 进行中 2 已结束
            timeInfo: {
                d: 0,
                h: 0,
                m: 0,
                s: 0
            }
        }
    },
    created () {

    },
    activated () {

    },
    watch: { },
    mounted () { },
    beforeDestroy () {
        this.$refs.countDown.end()
    },
    methods: {
        /**
         * 开始倒计时
         */
        startCountDown () {
            this.$refs.countDown.end()
            this.$refs.countDown.start()
        },
        /**
         * 倒计时回调
         * @param {object} timeInfo
         */
        onCountDownCallBack (timeInfo) {
            this.timeInfo = timeInfo
            this.$emit('callBack', timeInfo)
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '../../../assets/stylus/variables'
.countDownBox
    text-align center
    .bgBox
        position relative
        height 350px
        overflow hidden
        img
            height 100%
        .endCountDown
            position absolute
            bottom 47px
            left 50%
            transform translate(-50%, 0%)
            background #fff
            width 350px
            height 120px
            text-align center
            .p1
                color #fc2d2d
                font-size 32px
                line-height 48px
                margin 12px 0 0 0
    .pBox
        font-size 22px
        color #fc2d2d
        p
            display inline-block
            span
                vertical-align middle
                display inline-block
                min-width 38px
                height 38px
                text-align center
                line-height 38px
                background-color #000000
                border-radius 4px
                font-size 24px
                color #fff
                margin 9px
</style>
